import { render } from "./home-banner.vue?vue&type=template&id=4223bf99"
import script from "./home-banner.vue?vue&type=script&lang=js"
export * from "./home-banner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__